import { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';

import NavbarComponent from './components/Navbar';
import Footer from './components/Footer';
import ErrorPage from './pages/ErrorPage';

import PublicRoutes from './router/PublicRoutes';
import ClinicRoutes from './router/ClinicRoutes';
import AdminRoutes from './router/AdminRoutes';
import LoginRoutes from './router/LoginRoutes';

import {
  useUserPermissions,
} from './hooks/useUserPermissions';
import CookieConsent from './components/CookieConsent';
import { ModalProvider } from './contexts/ModalProvider';
import VLibras from "react-vlibras";
import ScrollToTopOrHash from './components/ScrollToTopOrHash';
import MyAccount from './pages/MyAccount';


const apiUrl = process.env.REACT_APP_API_URL || '';

const AppContent = () => {
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useUserPermissions(apiUrl, setMenuItems, setPermissions, setUser, () => setLoading(false));

  return (
    <ModalProvider>
      <VLibras safeInit avatar={'hosana'} />
      <ScrollToTopOrHash />
      <NavbarComponent menuItems={menuItems} />
      <Routes>
        <Route path="/*" element={<PublicRoutes />} />
        <Route path="/login/*" element={<LoginRoutes user={user} loading={loading} />} />
        <Route path="/consultorio/*" element={<ClinicRoutes user={user} permissions={permissions} loading={loading} />} />
        <Route path="/admin/*" element={<AdminRoutes user={user} permissions={permissions} loading={loading} />} />
        <Route path="/minha-conta" element={<MyAccount user={user} permissions={permissions} loading={loading} />} />

        <Route path='*' element={<ErrorPage code={404} />} />
      </Routes>
      <CookieConsent />
      <Footer />
    </ModalProvider>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
